import type { ReactNode } from 'react';

import { PageHeader } from '@shared/index';

import { AgentProfileWrapper } from './agent-profile.styles';

interface AgentProfileContainerProps {
  label: string;
  children: ReactNode;
  isWithHeaderPadding?: boolean;
}

export const AgentProfileContainer = ({
  label,
  children,
  isWithHeaderPadding = true,
}: AgentProfileContainerProps) => {
  return (
    <AgentProfileWrapper>
      <PageHeader $padding={isWithHeaderPadding ? [0, 16] : undefined}>
        {label}
      </PageHeader>
      {children}
    </AgentProfileWrapper>
  );
};
